import React from 'react';

import MuiIconButton, {
  IconButtonProps as MuiIconButtonProps,
} from '@mui/material/IconButton';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const IconButton = withCoreProps<IconButtonProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<IconButtonProps>) => {
    // const classes = useStyles({});
    const clsxClass = clsx(className);

    return (
      <MuiIconButton {...props} className={clsxClass}>
        {children}
      </MuiIconButton>
    );
  },
);

export interface IconButtonProps extends MuiIconButtonProps, CoreProps {}
